var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeheader"},[_c('div',{staticClass:"header-style"},[_c('side-menu'),_c('menu-search'),_c('user-icon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }